var map = {
	"./": 22182,
	"./app/App": 52407,
	"./app/App.jsx": 52407,
	"./app/App.module.scss": 10430,
	"./app/locale": 99747,
	"./app/locale/": 99747,
	"./app/locale/common/en": 81521,
	"./app/locale/common/en.json": 81521,
	"./app/locale/common/ru": 54842,
	"./app/locale/common/ru.json": 54842,
	"./app/locale/index": 99747,
	"./app/locale/index.js": 99747,
	"./app/locale/landing-page/en": 7035,
	"./app/locale/landing-page/en.json": 7035,
	"./app/locale/landing-page/ru": 37748,
	"./app/locale/landing-page/ru.json": 37748,
	"./app/router": 60573,
	"./app/router/": 60573,
	"./app/router/index": 60573,
	"./app/router/index.js": 60573,
	"./app/router/routes": 87223,
	"./app/router/routes.js": 87223,
	"./components": 59930,
	"./components/": 59930,
	"./components/Alert": 96651,
	"./components/Alert/": 96651,
	"./components/Alert/AlertDanger": 1989,
	"./components/Alert/AlertDanger/": 1989,
	"./components/Alert/AlertDanger/AlertDanger": 98282,
	"./components/Alert/AlertDanger/AlertDanger.js": 98282,
	"./components/Alert/AlertDanger/AlertDanger.module.scss": 79018,
	"./components/Alert/AlertDanger/index": 1989,
	"./components/Alert/AlertDanger/index.js": 1989,
	"./components/Alert/AlertSuccess": 21523,
	"./components/Alert/AlertSuccess/": 21523,
	"./components/Alert/AlertSuccess/AlertSuccess": 84433,
	"./components/Alert/AlertSuccess/AlertSuccess.js": 84433,
	"./components/Alert/AlertSuccess/AlertSuccess.module.scss": 68372,
	"./components/Alert/AlertSuccess/index": 21523,
	"./components/Alert/AlertSuccess/index.js": 21523,
	"./components/Alert/index": 96651,
	"./components/Alert/index.js": 96651,
	"./components/AlertComponent": 51490,
	"./components/AlertComponent/": 51490,
	"./components/AlertComponent/AlertComponent": 73593,
	"./components/AlertComponent/AlertComponent.jsx": 73593,
	"./components/AlertComponent/AlertComponent.module.scss": 67806,
	"./components/AlertComponent/index": 51490,
	"./components/AlertComponent/index.js": 51490,
	"./components/Balance": 84177,
	"./components/Balance/": 84177,
	"./components/Balance/BalanceActionsMenu": 37853,
	"./components/Balance/BalanceActionsMenu/": 37853,
	"./components/Balance/BalanceActionsMenu/BalanceActionMenu": 87325,
	"./components/Balance/BalanceActionsMenu/BalanceActionMenu.jsx": 87325,
	"./components/Balance/BalanceActionsMenu/BalanceActionsMenu.module.scss": 29418,
	"./components/Balance/BalanceActionsMenu/assets/Dots.svg": 57560,
	"./components/Balance/BalanceActionsMenu/index": 37853,
	"./components/Balance/BalanceActionsMenu/index.js": 37853,
	"./components/Balance/index": 84177,
	"./components/Balance/index.js": 84177,
	"./components/Bills": 10841,
	"./components/Bills/": 10841,
	"./components/Bills/Bills": 89556,
	"./components/Bills/Bills.jsx": 89556,
	"./components/Bills/Bills.module.scss": 59220,
	"./components/Bills/index": 10841,
	"./components/Bills/index.js": 10841,
	"./components/BurgerMenu": 36254,
	"./components/BurgerMenu/": 36254,
	"./components/BurgerMenu/BurgerMenu": 38695,
	"./components/BurgerMenu/BurgerMenu.jsx": 38695,
	"./components/BurgerMenu/BurgerMenu.module.scss": 72983,
	"./components/BurgerMenu/assets/ProfileIcon.svg": 64034,
	"./components/BurgerMenu/index": 36254,
	"./components/BurgerMenu/index.js": 36254,
	"./components/CopyText": 2759,
	"./components/CopyText/": 2759,
	"./components/CopyText/CopyText": 69012,
	"./components/CopyText/CopyText.js": 69012,
	"./components/CopyText/CopyText.module.scss": 66039,
	"./components/CopyText/index": 2759,
	"./components/CopyText/index.js": 2759,
	"./components/Deposit": 47841,
	"./components/Deposit/": 47841,
	"./components/Deposit/SelectOption": 86712,
	"./components/Deposit/SelectOption/": 86712,
	"./components/Deposit/SelectOption/SelectOption": 67385,
	"./components/Deposit/SelectOption/SelectOption.jsx": 67385,
	"./components/Deposit/SelectOption/SelectOption.module.scss": 11658,
	"./components/Deposit/SelectOption/index": 86712,
	"./components/Deposit/SelectOption/index.js": 86712,
	"./components/Deposit/index": 47841,
	"./components/Deposit/index.js": 47841,
	"./components/Footer": 59014,
	"./components/Footer/": 59014,
	"./components/Footer/Footer": 85269,
	"./components/Footer/Footer.jsx": 85269,
	"./components/Footer/Footer.module.scss": 86540,
	"./components/Footer/index": 59014,
	"./components/Footer/index.js": 59014,
	"./components/Header": 54478,
	"./components/Header/": 54478,
	"./components/Header/Header": 58396,
	"./components/Header/Header.jsx": 58396,
	"./components/Header/Header.module.scss": 15374,
	"./components/Header/index": 54478,
	"./components/Header/index.js": 54478,
	"./components/InfoModal": 70987,
	"./components/InfoModal/": 70987,
	"./components/InfoModal/InfoModal": 92228,
	"./components/InfoModal/InfoModal.jsx": 92228,
	"./components/InfoModal/InfoModal.module.scss": 96587,
	"./components/InfoModal/index": 70987,
	"./components/InfoModal/index.js": 70987,
	"./components/LanguageMenu": 51012,
	"./components/LanguageMenu/": 51012,
	"./components/LanguageMenu/LanguageMenu": 82918,
	"./components/LanguageMenu/LanguageMenu.jsx": 82918,
	"./components/LanguageMenu/LanguageMenu.module.scss": 27636,
	"./components/LanguageMenu/LanguageMenuIcon": 74362,
	"./components/LanguageMenu/LanguageMenuIcon.jsx": 74362,
	"./components/LanguageMenu/assets/DE.svg": 50390,
	"./components/LanguageMenu/assets/EE.svg": 3124,
	"./components/LanguageMenu/assets/EN.svg": 63386,
	"./components/LanguageMenu/assets/ES.svg": 33803,
	"./components/LanguageMenu/assets/FR.svg": 85954,
	"./components/LanguageMenu/assets/RU.svg": 72077,
	"./components/LanguageMenu/assets/TR.svg": 44268,
	"./components/LanguageMenu/index": 51012,
	"./components/LanguageMenu/index.js": 51012,
	"./components/LoginButton": 6592,
	"./components/LoginButton/": 6592,
	"./components/LoginButton/LoginButton": 36795,
	"./components/LoginButton/LoginButton.jsx": 36795,
	"./components/LoginButton/LoginButton.module.scss": 45076,
	"./components/LoginButton/assets/Key.svg": 21866,
	"./components/LoginButton/assets/Medal.svg": 43411,
	"./components/LoginButton/assets/ProfileIcon.svg": 16019,
	"./components/LoginButton/assets/Referal.svg": 72062,
	"./components/LoginButton/assets/SignOut.svg": 7419,
	"./components/LoginButton/assets/Verified.png": 41311,
	"./components/LoginButton/index": 6592,
	"./components/LoginButton/index.js": 6592,
	"./components/Menu": 68468,
	"./components/Menu/": 68468,
	"./components/Menu/Menu": 43744,
	"./components/Menu/Menu.jsx": 43744,
	"./components/Menu/Menu.module.scss": 84460,
	"./components/Menu/index": 68468,
	"./components/Menu/index.js": 68468,
	"./components/Nav": 40010,
	"./components/Nav/": 40010,
	"./components/Nav/Nav": 68487,
	"./components/Nav/Nav.jsx": 68487,
	"./components/Nav/Nav.module.scss": 2281,
	"./components/Nav/index": 40010,
	"./components/Nav/index.js": 40010,
	"./components/SideBar": 91320,
	"./components/SideBar/": 91320,
	"./components/SideBar/SideBar": 18652,
	"./components/SideBar/SideBar.jsx": 18652,
	"./components/SideBar/SideBar.module.scss": 52721,
	"./components/SideBar/index": 91320,
	"./components/SideBar/index.js": 91320,
	"./components/Timer": 59822,
	"./components/Timer/": 59822,
	"./components/Timer/Timer": 22834,
	"./components/Timer/Timer.jsx": 22834,
	"./components/Timer/index": 59822,
	"./components/Timer/index.js": 59822,
	"./components/Trade": 3055,
	"./components/Trade/": 3055,
	"./components/Trade/Arbitrage": 70549,
	"./components/Trade/Arbitrage/": 70549,
	"./components/Trade/Arbitrage/Arbitrage": 95520,
	"./components/Trade/Arbitrage/Arbitrage.jsx": 95520,
	"./components/Trade/Arbitrage/Arbitrage.module.scss": 50217,
	"./components/Trade/Arbitrage/index": 70549,
	"./components/Trade/Arbitrage/index.js": 70549,
	"./components/Trade/Autorobot": 68706,
	"./components/Trade/Autorobot/": 68706,
	"./components/Trade/Autorobot/Autorobot": 85831,
	"./components/Trade/Autorobot/Autorobot.jsx": 85831,
	"./components/Trade/Autorobot/Autorobot.module.scss": 64296,
	"./components/Trade/Autorobot/index": 68706,
	"./components/Trade/Autorobot/index.js": 68706,
	"./components/Trade/AutorobotForm": 82804,
	"./components/Trade/AutorobotForm/": 82804,
	"./components/Trade/AutorobotForm/AutorobotForm": 68943,
	"./components/Trade/AutorobotForm/AutorobotForm.jsx": 68943,
	"./components/Trade/AutorobotForm/AutorobotForm.module.scss": 70780,
	"./components/Trade/AutorobotForm/index": 82804,
	"./components/Trade/AutorobotForm/index.js": 82804,
	"./components/Trade/ExchangeTable": 40620,
	"./components/Trade/ExchangeTable/": 40620,
	"./components/Trade/ExchangeTable/ExchangeTable": 55386,
	"./components/Trade/ExchangeTable/ExchangeTable.jsx": 55386,
	"./components/Trade/ExchangeTable/ExchangeTable.module.scss": 72741,
	"./components/Trade/ExchangeTable/index": 40620,
	"./components/Trade/ExchangeTable/index.js": 40620,
	"./components/Trade/Graphs": 16383,
	"./components/Trade/Graphs/": 16383,
	"./components/Trade/Graphs/Graphs": 43821,
	"./components/Trade/Graphs/Graphs.jsx": 43821,
	"./components/Trade/Graphs/Graphs.module.scss": 50477,
	"./components/Trade/Graphs/index": 16383,
	"./components/Trade/Graphs/index.js": 16383,
	"./components/Trade/History": 12356,
	"./components/Trade/History/": 12356,
	"./components/Trade/History/History": 95938,
	"./components/Trade/History/History.jsx": 95938,
	"./components/Trade/History/History.module.scss": 40246,
	"./components/Trade/History/index": 12356,
	"./components/Trade/History/index.js": 12356,
	"./components/Trade/index": 3055,
	"./components/Trade/index.js": 3055,
	"./components/VerificationWarning": 23093,
	"./components/VerificationWarning/": 23093,
	"./components/VerificationWarning/VerificationWarning": 29788,
	"./components/VerificationWarning/VerificationWarning.jsx": 29788,
	"./components/VerificationWarning/VerificationWarning.module.scss": 47588,
	"./components/VerificationWarning/index": 23093,
	"./components/VerificationWarning/index.js": 23093,
	"./components/WidgetBalance": 81963,
	"./components/WidgetBalance/": 81963,
	"./components/WidgetBalance/WidgetBalance": 78394,
	"./components/WidgetBalance/WidgetBalance.jsx": 78394,
	"./components/WidgetBalance/WidgetBalance.module.scss": 45164,
	"./components/WidgetBalance/index": 81963,
	"./components/WidgetBalance/index.js": 81963,
	"./components/WidgetCreatePayment": 11335,
	"./components/WidgetCreatePayment/": 11335,
	"./components/WidgetCreatePayment/WidgetCreatePayment": 36427,
	"./components/WidgetCreatePayment/WidgetCreatePayment.jsx": 36427,
	"./components/WidgetCreatePayment/WidgetCreatePayment.module.scss": 60228,
	"./components/WidgetCreatePayment/index": 11335,
	"./components/WidgetCreatePayment/index.js": 11335,
	"./components/WidgetHistoryPayment": 2508,
	"./components/WidgetHistoryPayment/": 2508,
	"./components/WidgetHistoryPayment/WidgetHistoryPayment": 23377,
	"./components/WidgetHistoryPayment/WidgetHistoryPayment.jsx": 23377,
	"./components/WidgetHistoryPayment/WidgetHistoryPayment.module.scss": 26452,
	"./components/WidgetHistoryPayment/index": 2508,
	"./components/WidgetHistoryPayment/index.js": 2508,
	"./components/WidgetStat/WidgetStat": 69411,
	"./components/WidgetStat/WidgetStat.jsx": 69411,
	"./components/WidgetStat/WidgetStat.module.scss": 40700,
	"./components/WidgetStatPayments": 23765,
	"./components/WidgetStatPayments/": 23765,
	"./components/WidgetStatPayments/WidgetStatPayments": 51972,
	"./components/WidgetStatPayments/WidgetStatPayments.jsx": 51972,
	"./components/WidgetStatPayments/WidgetStatPayments.module.scss": 84716,
	"./components/WidgetStatPayments/index": 23765,
	"./components/WidgetStatPayments/index.js": 23765,
	"./components/WithdrawalModal": 56328,
	"./components/WithdrawalModal/": 56328,
	"./components/WithdrawalModal/WithdrawalModal": 55548,
	"./components/WithdrawalModal/WithdrawalModal.jsx": 55548,
	"./components/WithdrawalModal/WithdrawalModal.module.scss": 78992,
	"./components/WithdrawalModal/index": 56328,
	"./components/WithdrawalModal/index.js": 56328,
	"./components/index": 59930,
	"./components/index.js": 59930,
	"./hooks": 14717,
	"./hooks/": 14717,
	"./hooks/index": 14717,
	"./hooks/index.js": 14717,
	"./hooks/useClickOutside": 37855,
	"./hooks/useClickOutside.js": 37855,
	"./hooks/useWindowSize": 94397,
	"./hooks/useWindowSize.js": 94397,
	"./http": 26196,
	"./http/": 26196,
	"./http/adminApi": 47680,
	"./http/adminApi.js": 47680,
	"./http/index": 26196,
	"./http/index.js": 26196,
	"./http/siteAPI": 46296,
	"./http/siteAPI.js": 46296,
	"./http/tradeAPI": 56042,
	"./http/tradeAPI.js": 56042,
	"./http/userAPI": 43514,
	"./http/userAPI.js": 43514,
	"./http/walletAPI": 2160,
	"./http/walletAPI.js": 2160,
	"./index": 22182,
	"./index.js": 22182,
	"./index.scss": 50277,
	"./pages": 14812,
	"./pages/": 14812,
	"./pages/AdminLocalkassaBalance": 47257,
	"./pages/AdminLocalkassaBalance/": 47257,
	"./pages/AdminLocalkassaBalance/AdminLocalkassaBalance": 21277,
	"./pages/AdminLocalkassaBalance/AdminLocalkassaBalance.jsx": 21277,
	"./pages/AdminLocalkassaBalance/AdminLocalkassaBalance.module.scss": 51889,
	"./pages/AdminLocalkassaBalance/index": 47257,
	"./pages/AdminLocalkassaBalance/index.js": 47257,
	"./pages/AdminUserBalance": 55745,
	"./pages/AdminUserBalance/": 55745,
	"./pages/AdminUserBalance/AdminUserBalance": 63185,
	"./pages/AdminUserBalance/AdminUserBalance.jsx": 63185,
	"./pages/AdminUserBalance/AdminUserBalance.module.scss": 55343,
	"./pages/AdminUserBalance/index": 55745,
	"./pages/AdminUserBalance/index.js": 55745,
	"./pages/Api": 83803,
	"./pages/Api/": 83803,
	"./pages/Api/Api": 19837,
	"./pages/Api/Api.jsx": 19837,
	"./pages/Api/Api.module.scss": 84522,
	"./pages/Api/index": 83803,
	"./pages/Api/index.js": 83803,
	"./pages/Balance": 50878,
	"./pages/Balance/": 50878,
	"./pages/Balance/Balance": 29339,
	"./pages/Balance/Balance.jsx": 29339,
	"./pages/Balance/Balance.module.scss": 15483,
	"./pages/Balance/index": 50878,
	"./pages/Balance/index.js": 50878,
	"./pages/ChangePassword": 63115,
	"./pages/ChangePassword/": 63115,
	"./pages/ChangePassword/ChangePassword": 8120,
	"./pages/ChangePassword/ChangePassword.jsx": 8120,
	"./pages/ChangePassword/ChangePassword.module.scss": 96484,
	"./pages/ChangePassword/index": 63115,
	"./pages/ChangePassword/index.js": 63115,
	"./pages/ConfirmEmailData": 53325,
	"./pages/ConfirmEmailData/": 53325,
	"./pages/ConfirmEmailData/ConfirmEmailData": 64745,
	"./pages/ConfirmEmailData/ConfirmEmailData.jsx": 64745,
	"./pages/ConfirmEmailData/ConfirmEmailData.module.scss": 67973,
	"./pages/ConfirmEmailData/assets/Message.png": 65467,
	"./pages/ConfirmEmailData/index": 53325,
	"./pages/ConfirmEmailData/index.js": 53325,
	"./pages/Contacts": 83688,
	"./pages/Contacts/": 83688,
	"./pages/Contacts/Contact.module.scss": 44626,
	"./pages/Contacts/Contacts": 969,
	"./pages/Contacts/Contacts.jsx": 969,
	"./pages/Contacts/index": 83688,
	"./pages/Contacts/index.js": 83688,
	"./pages/CreateProject": 56353,
	"./pages/CreateProject/": 56353,
	"./pages/CreateProject/CreateProject": 29502,
	"./pages/CreateProject/CreateProject.jsx": 29502,
	"./pages/CreateProject/CreateProject.module.scss": 64307,
	"./pages/CreateProject/index": 56353,
	"./pages/CreateProject/index.js": 56353,
	"./pages/Dashboard": 17054,
	"./pages/Dashboard/": 17054,
	"./pages/Dashboard/Dashboard": 45279,
	"./pages/Dashboard/Dashboard.jsx": 45279,
	"./pages/Dashboard/index": 17054,
	"./pages/Dashboard/index.js": 17054,
	"./pages/Fees": 73838,
	"./pages/Fees/": 73838,
	"./pages/Fees/Fees": 18094,
	"./pages/Fees/Fees.jsx": 18094,
	"./pages/Fees/Fees.module.scss": 22774,
	"./pages/Fees/index": 73838,
	"./pages/Fees/index.js": 73838,
	"./pages/Information": 27693,
	"./pages/Information/": 27693,
	"./pages/Information/Information": 77613,
	"./pages/Information/Information.jsx": 77613,
	"./pages/Information/Information.module.scss": 44736,
	"./pages/Information/index": 27693,
	"./pages/Information/index.js": 27693,
	"./pages/MainPage": 39339,
	"./pages/MainPage/": 39339,
	"./pages/MainPage/MainPage": 30852,
	"./pages/MainPage/MainPage.jsx": 30852,
	"./pages/MainPage/MainPage.module.scss": 5658,
	"./pages/MainPage/index": 39339,
	"./pages/MainPage/index.js": 39339,
	"./pages/Merchant": 47693,
	"./pages/Merchant/": 47693,
	"./pages/Merchant/Merchant": 50490,
	"./pages/Merchant/Merchant.jsx": 50490,
	"./pages/Merchant/Merchant.module.scss": 62726,
	"./pages/Merchant/index": 47693,
	"./pages/Merchant/index.js": 47693,
	"./pages/MerchantCreatePage": 50632,
	"./pages/MerchantCreatePage/": 50632,
	"./pages/MerchantCreatePage/MerchantCreatePage": 33944,
	"./pages/MerchantCreatePage/MerchantCreatePage.jsx": 33944,
	"./pages/MerchantCreatePage/MerchantCreatePage.module.scss": 4837,
	"./pages/MerchantCreatePage/index": 50632,
	"./pages/MerchantCreatePage/index.js": 50632,
	"./pages/News": 14411,
	"./pages/News/": 14411,
	"./pages/News/News": 64197,
	"./pages/News/News.jsx": 64197,
	"./pages/News/News.module.scss": 31585,
	"./pages/News/index": 14411,
	"./pages/News/index.js": 14411,
	"./pages/NewsItem": 66146,
	"./pages/NewsItem/": 66146,
	"./pages/NewsItem/NewsItem": 18896,
	"./pages/NewsItem/NewsItem.jsx": 18896,
	"./pages/NewsItem/NewsItem.module.scss": 16178,
	"./pages/NewsItem/index": 66146,
	"./pages/NewsItem/index.js": 66146,
	"./pages/Page": 66185,
	"./pages/Page/": 66185,
	"./pages/Page/Page": 73773,
	"./pages/Page/Page.js": 73773,
	"./pages/Page/Page.module.scss": 49529,
	"./pages/Page/index": 66185,
	"./pages/Page/index.js": 66185,
	"./pages/Partner": 87240,
	"./pages/Partner/": 87240,
	"./pages/Partner/Partner": 37196,
	"./pages/Partner/Partner.jsx": 37196,
	"./pages/Partner/Partner.module.scss": 37807,
	"./pages/Partner/index": 87240,
	"./pages/Partner/index.js": 87240,
	"./pages/Pay": 7351,
	"./pages/Pay/": 7351,
	"./pages/Pay/Pay": 74492,
	"./pages/Pay/Pay.jsx": 74492,
	"./pages/Pay/Pay.module.scss": 88306,
	"./pages/Pay/Pay2": 6153,
	"./pages/Pay/Pay2.js": 6153,
	"./pages/Pay/index": 7351,
	"./pages/Pay/index.js": 7351,
	"./pages/PayPayeer": 25007,
	"./pages/PayPayeer/": 25007,
	"./pages/PayPayeer/PayPayeer": 92539,
	"./pages/PayPayeer/PayPayeer.jsx": 92539,
	"./pages/PayPayeer/PayPayeer.module.scss": 98768,
	"./pages/PayPayeer/index": 25007,
	"./pages/PayPayeer/index.js": 25007,
	"./pages/Payments": 14352,
	"./pages/Payments/": 14352,
	"./pages/Payments/Payments": 39495,
	"./pages/Payments/Payments.jsx": 39495,
	"./pages/Payments/Payments.module.scss": 33779,
	"./pages/Payments/index": 14352,
	"./pages/Payments/index.js": 14352,
	"./pages/Projects": 66699,
	"./pages/Projects/": 66699,
	"./pages/Projects/Projects": 12378,
	"./pages/Projects/Projects.jsx": 12378,
	"./pages/Projects/Projects.module.scss": 91560,
	"./pages/Projects/index": 66699,
	"./pages/Projects/index.js": 66699,
	"./pages/RestoreEmailSent": 57749,
	"./pages/RestoreEmailSent/": 57749,
	"./pages/RestoreEmailSent/RestoreEmailSent": 26563,
	"./pages/RestoreEmailSent/RestoreEmailSent.jsx": 26563,
	"./pages/RestoreEmailSent/RestoreEmailSent.module.scss": 85469,
	"./pages/RestoreEmailSent/assets/Message.png": 30440,
	"./pages/RestoreEmailSent/index": 57749,
	"./pages/RestoreEmailSent/index.js": 57749,
	"./pages/RestorePassword": 94950,
	"./pages/RestorePassword/": 94950,
	"./pages/RestorePassword/RestorePassword": 77196,
	"./pages/RestorePassword/RestorePassword.jsx": 77196,
	"./pages/RestorePassword/RestorePassword.module.scss": 52650,
	"./pages/RestorePassword/RestorePasswordCreate": 51245,
	"./pages/RestorePassword/RestorePasswordCreate.jsx": 51245,
	"./pages/RestorePassword/index": 94950,
	"./pages/RestorePassword/index.js": 94950,
	"./pages/Security": 32353,
	"./pages/Security/": 32353,
	"./pages/Security/Security": 36776,
	"./pages/Security/Security.jsx": 36776,
	"./pages/Security/Security.module.scss": 46385,
	"./pages/Security/index": 32353,
	"./pages/Security/index.js": 32353,
	"./pages/Setting": 58644,
	"./pages/Setting/": 58644,
	"./pages/Setting/Setting": 65976,
	"./pages/Setting/Setting.jsx": 65976,
	"./pages/Setting/Setting.module.scss": 7275,
	"./pages/Setting/index": 58644,
	"./pages/Setting/index.js": 58644,
	"./pages/SignIn": 24686,
	"./pages/SignIn/": 24686,
	"./pages/SignIn/SignIn": 40561,
	"./pages/SignIn/SignIn.jsx": 40561,
	"./pages/SignIn/SignIn.module.scss": 19420,
	"./pages/SignIn/index": 24686,
	"./pages/SignIn/index.js": 24686,
	"./pages/SignUp": 90,
	"./pages/SignUp/": 90,
	"./pages/SignUp/SignUp": 91543,
	"./pages/SignUp/SignUp.jsx": 91543,
	"./pages/SignUp/SignUp.module.scss": 34750,
	"./pages/SignUp/index": 90,
	"./pages/SignUp/index.js": 90,
	"./pages/Support": 84836,
	"./pages/Support/": 84836,
	"./pages/Support/Support": 84439,
	"./pages/Support/Support.jsx": 84439,
	"./pages/Support/Support.module.scss": 40805,
	"./pages/Support/index": 84836,
	"./pages/Support/index.js": 84836,
	"./pages/index": 14812,
	"./pages/index.js": 14812,
	"./store/actionCreators/siteActionCreator": 2506,
	"./store/actionCreators/siteActionCreator.js": 2506,
	"./store/actionCreators/tradeActionCreator": 58883,
	"./store/actionCreators/tradeActionCreator.js": 58883,
	"./store/actionCreators/userActionCreator": 1930,
	"./store/actionCreators/userActionCreator.js": 1930,
	"./store/actions/SiteAction": 86763,
	"./store/actions/SiteAction.js": 86763,
	"./store/actions/TradeAction": 78310,
	"./store/actions/TradeAction.js": 78310,
	"./store/actions/UserAction": 37065,
	"./store/actions/UserAction.js": 37065,
	"./store/asyncActions/asyncSiteAction": 93705,
	"./store/asyncActions/asyncSiteAction.js": 93705,
	"./store/asyncActions/asyncTradeAction": 28424,
	"./store/asyncActions/asyncTradeAction.js": 28424,
	"./store/reducers/rootReducer": 69827,
	"./store/reducers/rootReducer.js": 69827,
	"./store/reducers/siteReducer": 31565,
	"./store/reducers/siteReducer.js": 31565,
	"./store/reducers/tradeReducer": 39081,
	"./store/reducers/tradeReducer.js": 39081,
	"./store/reducers/userReducer": 76887,
	"./store/reducers/userReducer.js": 76887,
	"./store/store": 6338,
	"./store/store.js": 6338,
	"./ui-kit/assets": 26871,
	"./ui-kit/assets/": 26871,
	"./ui-kit/assets/AVAX.svg": 9810,
	"./ui-kit/assets/Arrow.svg": 6102,
	"./ui-kit/assets/BCH.png": 21296,
	"./ui-kit/assets/BNB,_native_cryptocurrency_for_the_Binance_Smart_Chain.svg.png": 64448,
	"./ui-kit/assets/BTC.png": 80273,
	"./ui-kit/assets/BTCABC.png": 9860,
	"./ui-kit/assets/Burger.svg": 6072,
	"./ui-kit/assets/Close.svg": 66428,
	"./ui-kit/assets/DASH.png": 96875,
	"./ui-kit/assets/ETC.png": 35371,
	"./ui-kit/assets/ETH.png": 52463,
	"./ui-kit/assets/EUR.png": 32714,
	"./ui-kit/assets/LTC.png": 50362,
	"./ui-kit/assets/Logo.svg": 62803,
	"./ui-kit/assets/XRP.png": 16080,
	"./ui-kit/assets/XTVCDOGE--big.svg": 30430,
	"./ui-kit/assets/XTVCTRX--big.svg": 1851,
	"./ui-kit/assets/XTVCUSDT--big.svg": 31092,
	"./ui-kit/assets/berty-api.zip": 2926,
	"./ui-kit/assets/channels4_profile.jpg": 37731,
	"./ui-kit/assets/develop-a-rest-api-to-your-mobile-application-rOPxKaxYDI.jpg": 3601,
	"./ui-kit/assets/dolary.png": 7432,
	"./ui-kit/assets/ico.png": 14167,
	"./ui-kit/assets/index": 26871,
	"./ui-kit/assets/index.js": 26871,
	"./ui-kit/assets/logo-horizontal.png": 36742,
	"./ui-kit/assets/logo.png": 59423,
	"./ui-kit/assets/perfectmoney-api.doc": 92569,
	"./ui-kit/assets/shutterstock_687394963-1.jpg": 92045,
	"./ui-kit/assets/zcash.png": 42309,
	"./ui-kit/components": 13378,
	"./ui-kit/components/": 13378,
	"./ui-kit/components/Accordeon": 52669,
	"./ui-kit/components/Accordeon/": 52669,
	"./ui-kit/components/Accordeon/Accordeon": 20301,
	"./ui-kit/components/Accordeon/Accordeon.jsx": 20301,
	"./ui-kit/components/Accordeon/Accordeon.module.scss": 23636,
	"./ui-kit/components/Accordeon/index": 52669,
	"./ui-kit/components/Accordeon/index.js": 52669,
	"./ui-kit/components/ActionButton": 89509,
	"./ui-kit/components/ActionButton/": 89509,
	"./ui-kit/components/ActionButton/ActionButton": 38953,
	"./ui-kit/components/ActionButton/ActionButton.jsx": 38953,
	"./ui-kit/components/ActionButton/ActionButton.module.scss": 3552,
	"./ui-kit/components/ActionButton/index": 89509,
	"./ui-kit/components/ActionButton/index.js": 89509,
	"./ui-kit/components/Arrow": 28034,
	"./ui-kit/components/Arrow/": 28034,
	"./ui-kit/components/Arrow/Arrow": 85381,
	"./ui-kit/components/Arrow/Arrow.jsx": 85381,
	"./ui-kit/components/Arrow/Arrow.module.scss": 36611,
	"./ui-kit/components/Arrow/index": 28034,
	"./ui-kit/components/Arrow/index.js": 28034,
	"./ui-kit/components/Card": 51638,
	"./ui-kit/components/Card/": 51638,
	"./ui-kit/components/Card/Card": 59551,
	"./ui-kit/components/Card/Card.jsx": 59551,
	"./ui-kit/components/Card/Card.module.scss": 79678,
	"./ui-kit/components/Card/index": 51638,
	"./ui-kit/components/Card/index.js": 51638,
	"./ui-kit/components/Checkbox": 15091,
	"./ui-kit/components/Checkbox/": 15091,
	"./ui-kit/components/Checkbox/Checkbox": 92159,
	"./ui-kit/components/Checkbox/Checkbox.jsx": 92159,
	"./ui-kit/components/Checkbox/Checkbox.module.scss": 16288,
	"./ui-kit/components/Checkbox/assets/Checkbox.svg": 4716,
	"./ui-kit/components/Checkbox/index": 15091,
	"./ui-kit/components/Checkbox/index.js": 15091,
	"./ui-kit/components/ColoredText": 56840,
	"./ui-kit/components/ColoredText/": 56840,
	"./ui-kit/components/ColoredText/ColoredText": 46121,
	"./ui-kit/components/ColoredText/ColoredText.jsx": 46121,
	"./ui-kit/components/ColoredText/ColoredText.module.scss": 79489,
	"./ui-kit/components/ColoredText/index": 56840,
	"./ui-kit/components/ColoredText/index.js": 56840,
	"./ui-kit/components/ControlButton": 84532,
	"./ui-kit/components/ControlButton/": 84532,
	"./ui-kit/components/ControlButton/ControlButton": 14188,
	"./ui-kit/components/ControlButton/ControlButton.jsx": 14188,
	"./ui-kit/components/ControlButton/ControlButton.module.scss": 66568,
	"./ui-kit/components/ControlButton/index": 84532,
	"./ui-kit/components/ControlButton/index.js": 84532,
	"./ui-kit/components/ControlButtonMenu": 89069,
	"./ui-kit/components/ControlButtonMenu/": 89069,
	"./ui-kit/components/ControlButtonMenu/ControlButtonMenu": 64601,
	"./ui-kit/components/ControlButtonMenu/ControlButtonMenu.jsx": 64601,
	"./ui-kit/components/ControlButtonMenu/ControlButtonMenu.module.scss": 57827,
	"./ui-kit/components/ControlButtonMenu/ControlButtonMenuCommon": 23296,
	"./ui-kit/components/ControlButtonMenu/ControlButtonMenuCommon.jsx": 23296,
	"./ui-kit/components/ControlButtonMenu/index": 89069,
	"./ui-kit/components/ControlButtonMenu/index.js": 89069,
	"./ui-kit/components/FileInput": 24633,
	"./ui-kit/components/FileInput/": 24633,
	"./ui-kit/components/FileInput/FileInput": 17783,
	"./ui-kit/components/FileInput/FileInput.jsx": 17783,
	"./ui-kit/components/FileInput/FileInput.module.scss": 71052,
	"./ui-kit/components/FileInput/assets/Scan.svg": 79422,
	"./ui-kit/components/FileInput/index": 24633,
	"./ui-kit/components/FileInput/index.js": 24633,
	"./ui-kit/components/HollowButton": 66851,
	"./ui-kit/components/HollowButton/": 66851,
	"./ui-kit/components/HollowButton/HollowButton": 88563,
	"./ui-kit/components/HollowButton/HollowButton.jsx": 88563,
	"./ui-kit/components/HollowButton/HollowButton.module.scss": 69368,
	"./ui-kit/components/HollowButton/index": 66851,
	"./ui-kit/components/HollowButton/index.js": 66851,
	"./ui-kit/components/Input": 6890,
	"./ui-kit/components/Input/": 6890,
	"./ui-kit/components/Input/Input": 55625,
	"./ui-kit/components/Input/Input.jsx": 55625,
	"./ui-kit/components/Input/Input.module.scss": 59155,
	"./ui-kit/components/Input/index": 6890,
	"./ui-kit/components/Input/index.js": 6890,
	"./ui-kit/components/InputText": 48879,
	"./ui-kit/components/InputText/": 48879,
	"./ui-kit/components/InputText/InputText": 51138,
	"./ui-kit/components/InputText/InputText.jsx": 51138,
	"./ui-kit/components/InputText/InputText.module.scss": 68090,
	"./ui-kit/components/InputText/index": 48879,
	"./ui-kit/components/InputText/index.js": 48879,
	"./ui-kit/components/PasswordInput": 27273,
	"./ui-kit/components/PasswordInput/": 27273,
	"./ui-kit/components/PasswordInput/PasswordInput": 23350,
	"./ui-kit/components/PasswordInput/PasswordInput.jsx": 23350,
	"./ui-kit/components/PasswordInput/PasswordInput.module.scss": 95505,
	"./ui-kit/components/PasswordInput/assets/EyeClosedIcon.svg": 70647,
	"./ui-kit/components/PasswordInput/assets/EyeIcon.svg": 53556,
	"./ui-kit/components/PasswordInput/index": 27273,
	"./ui-kit/components/PasswordInput/index.js": 27273,
	"./ui-kit/components/Select": 108,
	"./ui-kit/components/Select/": 108,
	"./ui-kit/components/Select/Select": 80766,
	"./ui-kit/components/Select/Select.jsx": 80766,
	"./ui-kit/components/Select/Select.module.scss": 1957,
	"./ui-kit/components/Select/index": 108,
	"./ui-kit/components/Select/index.js": 108,
	"./ui-kit/components/Table": 9001,
	"./ui-kit/components/Table/": 9001,
	"./ui-kit/components/Table/Table": 63819,
	"./ui-kit/components/Table/Table.jsx": 63819,
	"./ui-kit/components/Table/Table.module.scss": 5273,
	"./ui-kit/components/Table/index": 9001,
	"./ui-kit/components/Table/index.js": 9001,
	"./ui-kit/components/Textarea": 43258,
	"./ui-kit/components/Textarea/": 43258,
	"./ui-kit/components/Textarea/Textarea": 15789,
	"./ui-kit/components/Textarea/Textarea.jsx": 15789,
	"./ui-kit/components/Textarea/Textarea.module.scss": 12893,
	"./ui-kit/components/Textarea/index": 43258,
	"./ui-kit/components/Textarea/index.js": 43258,
	"./ui-kit/components/index": 13378,
	"./ui-kit/components/index.js": 13378,
	"./ui-kit/font/Gilroy-Black.eot": 32304,
	"./ui-kit/font/Gilroy-Black.ttf": 29110,
	"./ui-kit/font/Gilroy-Black.woff": 29224,
	"./ui-kit/font/Gilroy-BlackItalic.eot": 41217,
	"./ui-kit/font/Gilroy-BlackItalic.ttf": 1472,
	"./ui-kit/font/Gilroy-BlackItalic.woff": 67724,
	"./ui-kit/font/Gilroy-Bold.eot": 52818,
	"./ui-kit/font/Gilroy-Bold.ttf": 68320,
	"./ui-kit/font/Gilroy-Bold.woff": 58931,
	"./ui-kit/font/Gilroy-BoldItalic.eot": 5611,
	"./ui-kit/font/Gilroy-BoldItalic.ttf": 44454,
	"./ui-kit/font/Gilroy-BoldItalic.woff": 55884,
	"./ui-kit/font/Gilroy-ExtraBold.eot": 51247,
	"./ui-kit/font/Gilroy-ExtraBold.ttf": 82568,
	"./ui-kit/font/Gilroy-ExtraBold.woff": 32866,
	"./ui-kit/font/Gilroy-ExtraBoldItalic.eot": 93005,
	"./ui-kit/font/Gilroy-ExtraBoldItalic.ttf": 93965,
	"./ui-kit/font/Gilroy-ExtraBoldItalic.woff": 92246,
	"./ui-kit/font/Gilroy-Heavy.eot": 88766,
	"./ui-kit/font/Gilroy-Heavy.ttf": 19984,
	"./ui-kit/font/Gilroy-Heavy.woff": 50608,
	"./ui-kit/font/Gilroy-HeavyItalic.eot": 59841,
	"./ui-kit/font/Gilroy-HeavyItalic.ttf": 28426,
	"./ui-kit/font/Gilroy-HeavyItalic.woff": 72625,
	"./ui-kit/font/Gilroy-Light.eot": 68801,
	"./ui-kit/font/Gilroy-Light.ttf": 33799,
	"./ui-kit/font/Gilroy-Light.woff": 47679,
	"./ui-kit/font/Gilroy-LightItalic.eot": 55378,
	"./ui-kit/font/Gilroy-LightItalic.ttf": 41911,
	"./ui-kit/font/Gilroy-LightItalic.woff": 38283,
	"./ui-kit/font/Gilroy-Medium.eot": 81063,
	"./ui-kit/font/Gilroy-Medium.ttf": 55659,
	"./ui-kit/font/Gilroy-Medium.woff": 52701,
	"./ui-kit/font/Gilroy-MediumItalic.eot": 88089,
	"./ui-kit/font/Gilroy-MediumItalic.ttf": 20410,
	"./ui-kit/font/Gilroy-MediumItalic.woff": 678,
	"./ui-kit/font/Gilroy-Regular.eot": 25826,
	"./ui-kit/font/Gilroy-Regular.ttf": 17399,
	"./ui-kit/font/Gilroy-Regular.woff": 89127,
	"./ui-kit/font/Gilroy-RegularItalic.eot": 13115,
	"./ui-kit/font/Gilroy-RegularItalic.ttf": 78266,
	"./ui-kit/font/Gilroy-RegularItalic.woff": 40029,
	"./ui-kit/font/Gilroy-SemiBold.eot": 45012,
	"./ui-kit/font/Gilroy-SemiBold.ttf": 89131,
	"./ui-kit/font/Gilroy-SemiBold.woff": 13207,
	"./ui-kit/font/Gilroy-SemiBoldItalic.eot": 57177,
	"./ui-kit/font/Gilroy-SemiBoldItalic.ttf": 42396,
	"./ui-kit/font/Gilroy-SemiBoldItalic.woff": 3405,
	"./ui-kit/font/Gilroy-Thin.eot": 93116,
	"./ui-kit/font/Gilroy-Thin.ttf": 77969,
	"./ui-kit/font/Gilroy-Thin.woff": 63064,
	"./ui-kit/font/Gilroy-ThinItalic.eot": 45049,
	"./ui-kit/font/Gilroy-ThinItalic.ttf": 45091,
	"./ui-kit/font/Gilroy-ThinItalic.woff": 15931,
	"./ui-kit/font/Gilroy-UltraLight.eot": 56859,
	"./ui-kit/font/Gilroy-UltraLight.ttf": 54089,
	"./ui-kit/font/Gilroy-UltraLight.woff": 71625,
	"./ui-kit/font/Gilroy-UltraLightItalic.eot": 80741,
	"./ui-kit/font/Gilroy-UltraLightItalic.ttf": 33590,
	"./ui-kit/font/Gilroy-UltraLightItalic.woff": 64233,
	"./ui-kit/scss/classes.scss": 44917,
	"./ui-kit/scss/font-face.scss": 34809,
	"./ui-kit/scss/mixins.scss": 43798,
	"./ui-kit/scss/variables.scss": 63013,
	"./utils/consts": 22186,
	"./utils/consts.js": 22186,
	"./utils/currencies": 79966,
	"./utils/currencies.js": 79966,
	"./utils/function": 9602,
	"./utils/function.js": 9602
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18116;